<template>
    <div id="productPlanListContainer">
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            class="tableList"
            ref="tableRef"
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <!-- <a-button v-permission="'setting.plan.addPlan'" type="primary" size="mini" @click="handle('add')">
                    <icon-plus size="13" style="marginRight:5px;"/>
                    {{ $t('base.add') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.plan.addPlan'"/>
                <a-upload 
                    v-permission="'setting.plan.importFile'"
                    class="importFile" 
                    :file-list="fileList" 
                    :show-file-list="false" 
                    :limit="1" 
                    size="mini" 
                    @error="(fileList)=>Upload(fileList)" 
                >
                    <template #upload-button>
                        <a-button type="primary" size="mini" >
                            <icon-import size="13" style="marginRight:5px;"/>
                            {{ $t('plan.importFile') }}
                        </a-button>
                    </template>
                </a-upload>
                <a-divider direction="vertical" v-permission="'setting.plan.importFile'"/> -->
                <a-button v-permission="'setting.product.exportPlanFile'" type="primary" size="mini" :disabled="importing" @click="handle('exportFile')">
                    <icon-export size="13" style="marginRight:5px;"/>
                    {{ $t('plan.exportFile') }}
                </a-button>
                <a-divider direction="vertical" v-permission="'setting.product.splitOrder'"/>
                <a-button v-permission="'setting.product.splitOrder'" type="primary" size="mini" @click="handle('splitOrder')">
                    <icon-scissor size="13" style="marginRight:5px;"/>
                    {{ $t('plan.splitOrder') }}
                </a-button>
                <a-divider direction="vertical" />
                <a-button type="primary" size="mini" @click="handle('record')">
                    <icon-schedule size="13" style="marginRight:5px;"/>
                    {{ $t('plan.record') }}
                </a-button>
                <a-divider v-permission="'setting.product.maisachEdit'" direction="vertical" />
                <a-button v-permission="'setting.product.maisachEdit'" type="primary" size="mini" @click="handle('maisachEdit')">
                    <icon-pen-fill size="13" style="marginRight:5px;"/>
                    {{ $t('plan.maisachEdit') }}
                </a-button>
                <!-- <a-divider direction="vertical"  v-permission="'setting.plan.exportFile'"/>
                <a-button v-permission="'setting.plan.downloadTemplate'" type="primary" size="mini" :disabled="importing" @click="handle('downLoadImportTemplate')">
                    <icon-download size="13" style="marginRight:5px;"/>
                    {{ $t('plan.downloadTemplate') }}
                </a-button> -->
            </template>

            <template v-slot:tableOperate="{ props }">
                <!-- <a-button v-permission="'setting.product.editPlan'" type="primary" size="mini" @click="handle('edit',props.record)">
                    <icon-edit size="13" style="marginRight:5px;"/>
                    {{ $t('base.edit') }}
                </a-button> -->

                <!-- <a-button v-permission="'setting.product.editPlan'" type="primary" size="mini" @click="handle('edit',props.record)">
                    <icon-edit size="13" style="marginRight:5px;"/>
                    {{ $t('base.edit') }}
                </a-button> -->
                <!-- <a-divider direction="vertical" v-permission="'setting.plan.editPlan'"/>
                <a-button v-permission="'setting.plan.deletePlan'" type="primary" status="danger" size="mini" @click="handle('deletePlan',props.record)">
                    <icon-delete size="13" style="marginRight:5px;"/>
                    {{ $t('base.delete') }}
                </a-button> -->
            </template>
        </Table>

        <!-- 弹窗 -->
        <a-modal
            v-model:visible="visible" 
            width="30%"
            :title="$t('base.edit')"
            draggable
            :render-to-body="false"
            :mask-closable="false"
            :onBeforeOk="onBeforeOk"
        >
            <a-date-picker
                style="width: 254px; marginBottom: 20px;"
                v-model="recordDate"
                @change="onChange"
                @select="onSelect"
                :disabledDate="(current) => disabledDate(current)"
            />
        </a-modal>


        <!-- 拆分订单 sku弹窗 -->
        <a-modal
            v-model:visible="SKUVisible" 
            width="30%"
            :title="$t('base.edit')"
            draggable
            :render-to-body="false"
            :mask-closable="false"
            :onBeforeOk="onBeforeSelectSKUOk"
        >
            <a-select 
                :style="{width:'320px'}"
                v-model="sku" 
                allow-search
                :options="skuOption"
                @change="selectSKU"
            ></a-select>
        </a-modal>

        <!-- 拆分订单弹窗 -->
        <a-modal
            v-model:visible="splitVisible" 
            width="80%"
            :title="$t('base.edit')"
            draggable
            :ok-loading="saveDisabled"
            :render-to-body="false"
            :mask-closable="false"
            :onBeforeOk="saveSplitData"
            
        >
            <Table
                class="splitTable"
                ref="splitTableRef"
                :table="splitTable"
                @expandRow="expandRow"
                @selectRow="selectRow"
            >
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'quantity'">
                        <a-input-number 
                            v-model="props.record.quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'quantity')"
                        />
                    </div>
                    <div v-if="props.column.key == 'rest_quantity'">
                        <a-input-number 
                            v-model="props.record.rest_quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'rest_quantity')"
                        />
                    </div>
                    <div v-if="props.column.key == 'in_stock_quantity'">
                        <a-input-number 
                            v-model="props.record.in_stock_quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'in_stock_quantity')"
                        />
                    </div>
                    <div v-if="props.column.key == 'in_transit_quantity'">
                        <a-input-number 
                            v-model="props.record.in_transit_quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'in_transit_quantity')"
                        />
                    </div>
                    <div v-if="props.column.key == 'record_date'">
                        <a-date-picker 
                            style="width: 200px;" 
                            allow-clear
                            v-model="props.record.record_date"
                            :disabledDate="(current) => dayjs(current).isBefore(dayjs())"
                            @change="changeSplitDate(props.record)"
                        />
                    </div>
                </template>

                <template v-slot:tableOperate="{ props }">
                    <a-button type="primary" size="mini" @click="handle('addSplitLine',props.record)">
                        <icon-plus size="13" style="marginRight:5px;"/>
                        {{ $t('base.add') }}
                    </a-button> 
                </template>

                <template v-slot:childTableOperate="{ props }">
                    <a-button type="primary" status="danger" size="mini" @click="handle('deleteLine',props.record)">
                        <icon-delete size="13" style="marginRight:5px;"/>
                        {{ $t('base.delete') }}
                    </a-button> 
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                            <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                            <div class="searchFilter-footer">
                                <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                                <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                            </div>
                        </a-space>
                    </div>
                </template>
            </Table>
        </a-modal>

        <!-- maisach弹窗 -->
        <a-modal
            v-model:visible="maisachVisible" 
            width="80%"
            :title="$t('plan.maisachEdit')"
            draggable
            :ok-loading="saveDisabled"
            :render-to-body="false"
            :mask-closable="false"
            :onBeforeOk="updateMaisachStock"
        >
            <Table
                class="maisachTable"
                ref="maisachTableRef"
                :table="maisachTable"
                @selectRow="selectRowMaisach"
            >
                <template v-slot:columns="{ props }">
                    <!-- <div v-if="props.column.key == 'quantity'">
                        <a-input-number 
                            v-model="props.record.quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'maisach_quantity')"
                        />
                    </div>
                    <div v-if="props.column.key == 'rest_quantity'">
                        <a-input-number 
                            v-model="props.record.rest_quantity" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'maisach_rest_quantity')"
                        />
                    </div> -->
                    <div v-if="props.column.key == 'in_stock_quantity'">
                        <a-input-number 
                            v-model="props.record.in_stock_quantity" 
                            :style="{width:'160px',maxWidth:'100%'}"
                            :min="0"
                            :precision="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'maisach_in_stock_quantity')"
                        />
                    </div>
                    <!-- <div v-if="props.column.key == 'delivery_date'">
                        <a-input-number 
                            v-model="props.record.delivery_date" 
                            :style="{width:'160px'}"
                            :min="0"
                            hide-button
                            @input="(val)=>changeInputNumber(val, props.record, 'maisach_delivery_date')"
                        />
                    </div> -->
                </template>
            </Table>
        </a-modal>

        <!-- 历史记录 -->
        <a-modal 
            v-model:visible="recordVisible" 
            width="80%"
            :title="$t('plan.record')"
            draggable
            :render-to-body="false"
            :mask-closable="false"
            :footer="null"
        >
            <div class="queryPanel">
                    <Form 
                        :form="queryRecordForm" 
                        @handleSelectChange="handleSelectChangeRecord"
                        @handlePressEnter="handlePressEnterRecord"
                        @handleInputClear="handleInputClearRecord"
                    ></Form>
                    <a-dropdown-button style="margin-top:-10px; margin-left:10px" size="small" @click="handle('searchRecord')">
                        <icon-search size="14" style="marginRight:5px;"/>
                        {{ $t('base.search') }}
                        <template #content>
                            <a-doption @click="handle('resetRecord')">
                                <icon-refresh size="14" style="marginRight:5px;"/>
                                {{ $t('base.reset') }}
                            </a-doption>
                         </template>
                    </a-dropdown-button>
            </div>

            <Table 
                :table="recordTable"
                @changePage="changePageRecord"
                @changePageSize="changePageSizeRecord"
            ></Table>

        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { ProductApi } from '@/api/ProductApi.js';
    import { OrderApi } from '@/api/OrderApi.js'; 
    import { MenuItem, Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { PlanListQuery, AddForm, RecordListQuery } from './queryConfig/PlanListQuery.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import dayjs from 'dayjs';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const localeStore = useLocale()

    const { t } = useI18n()

    const queryForm = reactive(PlanListQuery)
    const showForm = ref(false)
    const queryRecordForm = reactive(RecordListQuery)
    const visible = ref(false)
    const SKUVisible = ref(false)
    const splitVisible = ref(false)
    const recordVisible = ref(false)
    const splitTableRef = ref(null)
    const maisachVisible = ref(false)
    const maisachTableRef = ref(null)
    const currentOperation = ref('')    
    const rowData = ref(null)
    const recordDate = ref('')
    const sku = ref('')
    const skuOption = ref([])
    const fileList = ref([])
    const saveDisabled = ref(false)
    const maisachTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'40',
                align:'center',
            },
            {
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'center',
            },
            {
                title: t('plan.processCode'),
                dataIndex: 'process_code',
                key:'process_code',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
                filterable: {
                    filter: (value, record) => record.process_code.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('plan.factory'),
                dataIndex: 'factory',
                key:'factory',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.restQuantity'),
                dataIndex: 'rest_quantity',
                key:'rest_quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.inStockQuantity'),
                dataIndex: 'in_stock_quantity',
                key:'in_stock_quantity',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName: 'slot'
            },
            {
                title: t('plan.deliveryDate'),
                dataIndex: 'record_date',
                key:'record_date',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: false,
                onlyCurrent: false,
                selected: [],
                defaultSelectedKeys: []
            },
            expandable:'',
            expand:false,
            selected:[],
            size:'large',
            loading:false,
            pagination:false,
            showOperationColumn: false,
        },
    })
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: 'SKU',
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            // {
            //     // title: '物料编码',
            //     title: t('plan.inventoryCode'),
            //     dataIndex: 'inventory_code',
            //     key:'inventory_code',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: 'PO号',
                title: t('plan.sourcePo'),
                dataIndex: 'source_po',
                key:'source_po',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('plan.processCode'),
                dataIndex: 'process_code',
                key:'process_code',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '工厂',
                title: t('plan.factory'),
                dataIndex: 'factory',
                key:'factory',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '数量',
                title: t('plan.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '',
                title: t('plan.restQuantity'),
                dataIndex: 'rest_quantity',
                key:'rest_quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.inTransitQuantity'),
                dataIndex: 'in_transit_quantity',
                key:'in_transit_quantity',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.inStockQuantity'),
                dataIndex: 'in_stock_quantity',
                key:'in_stock_quantity',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                // title: '年份',
                title: t('plan.recordYear'),
                dataIndex: 'record_year',
                key:'record_year',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '月份',
                title: t('plan.recordMonth'),
                dataIndex: 'record_month',
                key:'record_month',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '周别',
                title: t('plan.recordWeek'),
                dataIndex: 'record_week',
                key:'record_week',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '计划交期',
                title: t('plan.recordDate'),
                dataIndex: 'record_date',
                key:'record_date',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    const innerColumns = ref([
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'90',
                fixed:'left',
                align:'center',
            },
            {
                title: t('plan.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot',
            },
            {
                title: t('plan.restQuantity'),
                dataIndex: 'rest_quantity',
                key:'rest_quantity',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot',
            },
            {
                title: t('plan.inTransitQuantity'),
                dataIndex: 'in_transit_quantity',
                key:'in_transit_quantity',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot',
            },
            {
                title: t('plan.inStockQuantity'),
                dataIndex: 'in_stock_quantity',
                key:'in_stock_quantity',
                ellipsis:true,
                tooltip:true,
                align:'center',
                slotName:'slot',
            },
            {
                title: t('plan.recordDate'),
                dataIndex: 'record_date',
                key:'record_date',
                ellipsis:true,
                tooltip:true,  
                align:'center',
                slotName:'slot',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'120',
                align:'center',
                fixed:'right'
            }
    ])
    const innerConfigs = ref({
        scroll:{
            x:1000,
            y:560,
        },
        stripe:false,
        bordered:false,
        size:'large',
        loading:false,
        expandable:'',
        expand:false,
        pagination:false,
    })

    const splitTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'40',
                fixed:'left',
                align:'center',
            },
            {
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'170',
                ellipsis:true,
                tooltip:true,  
                align:'center',
            },
            {
                title: t('plan.processCode'),
                dataIndex: 'process_code',
                key:'process_code',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'center',
                filterable: {
                    filter: (value, record) => record.process_code.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                title: t('plan.factory'),
                dataIndex: 'factory',
                key:'factory',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.restQuantity'),
                dataIndex: 'rest_quantity',
                key:'rest_quantity',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.inTransitQuantity'),
                dataIndex: 'in_transit_quantity',
                key:'in_transit_quantity',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.inStockQuantity'),
                dataIndex: 'in_stock_quantity',
                key:'in_stock_quantity',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'80',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: false,
                onlyCurrent: false,
            },
            selected:[],
            size:'large',
            loading:false,
            pagination:false,
        },
    })

    const recordTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                ellipsis:true,
                tooltip:true,  
                align:'left',
            },
            {
                title: t('plan.sourcePo'),
                dataIndex: 'source_po',
                key:'source_po',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.processCode'),
                dataIndex: 'process_code',
                key:'process_code',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.factory'),
                dataIndex: 'factory',
                key:'factory',
                width:'100',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'90',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.restQuantity'),
                dataIndex: 'rest_quantity',
                key:'rest_quantity',
                width:'110',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.inTransitQuantity'),
                dataIndex: 'in_transit_quantity',
                key:'in_transit_quantity',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.inStockQuantity'),
                dataIndex: 'in_stock_quantity',
                key:'in_stock_quantity',
                width:'120',
                ellipsis:true,
                tooltip:true,
                align:'center',
            },
            {
                title: t('plan.recordDate'),
                dataIndex: 'record_date',
                key:'record_date',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                title: t('plan.versionCode'),
                dataIndex: 'batch_id',
                key:'batch_id',
                width:'150',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
        ],
        configs:{
            scroll:{
                x:1000,
                y:560,
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getPlanList()
                break;
            case 'reset':
                queryForm.formField.forEach(i=>{
                    queryForm.formData[i.key] = ''
                })
                queryForm.formData.begin_date = ''
                queryForm.formData.end_date = ''
                table.value.configs.pagination.current = 1
                getPlanList()
                break;
            case 'edit':
                visible.value = true
                recordDate.value = row.record_date
                rowData.value = row
                break;
            case 'exportFile':
                exportFile()
                break;
            case 'splitOrder':
                currentOperation.value = 'split'
                SKUVisible.value = true
                sku.value = ''
                break;
            case 'maisachEdit':
                currentOperation.value = 'maisach'
                SKUVisible.value = true
                sku.value = ''
                break;
            case 'addSplitLine':
                expandRow(row.id, row)
                row.child.innerDatas.push({
                    No: `${row.No}-${row.child.innerDatas.length + 1}`,
                    index: row.child.innerDatas.length,
                    quantity:'',
                    rest_quantity:0,
                    in_stock_quantity:0,
                    in_transit_quantity:0,
                    record_date:'',
                })
                // if(splitTable.value.configs.selected.length > 0){
                //     splitTable.value.configs.selected.forEach(i=>{
                //         if(i.id == rowData.value.id){
                //             i.child.innerDatas = rowData.value.child.innerDatas 
                //         }
                //     })
                // }
                // console.log(splitTable.value.configs.selected, 'sssss')
                break;
            case 'deleteLine':
                // console.log(row,'row eeeeeeee', rowData.value.child.innerDatas)
                rowData.value.child.innerDatas.splice(row.index, 1)
                rowData.value.child.innerDatas.forEach((i,index)=>{
                    i.No = `${rowData.value.No}-${index + 1}`
                    i.index = index
                })
                // if(splitTable.value.configs.selected.length > 0){
                //     splitTable.value.configs.selected.forEach(i=>{
                //         if(i.id == rowData.value.id){
                //             i.child.innerDatas = rowData.value.child.innerDatas 
                //         }
                //     })
                // }
                break;
            case 'record':
                recordVisible.value = true
                queryRecordForm.formField.forEach(i=>{
                    queryRecordForm.formData[i.key] = ''
                })
                getRecordList(row)
                break;
            case 'searchRecord':
                recordTable.value.configs.pagination.current = 1
                getRecordList()
                break;
            case 'resetRecord':
                queryRecordForm.formField.forEach(i=>{
                    queryRecordForm.formData[i.key] = ''
                })                      
                recordTable.value.configs.pagination.current = 1
                getRecordList()
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getPlanList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getPlanList()
    }

    const changePageRecord = (current)=>{
        recordTable.value.configs.pagination.current = current
        getRecordList()
    }   

    const changePageSizeRecord = (pageSize)=>{
        recordTable.value.configs.pagination.current = 1
        recordTable.value.configs.pagination.pageSize = pageSize
        getRecordList()
    }

    // 列表查询-input
    const handleSelectChange = (val,item)=>{
        table.value.configs.pagination.current = 1
        getPlanList()
    }
    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getPlanList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getPlanList()
    }

    const handleSelectChangeRecord = (val,item)=>{
        recordTable.value.configs.pagination.current = 1
        getRecordList()
    }           

    const handleInputClearRecord = (val,item)=>{
        recordTable.value.configs.pagination.current = 1
        getRecordList()
    }

    const handlePressEnterRecord = (val,item)=>{
        recordTable.value.configs.pagination.current = 1
        getRecordList()
    }

    const handlePickerDateChange = (val, item)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData.begin_date = !val? '' : dateToTimestamp(`${val[0]} 00:00:00`)
        queryForm.formData.end_date = !val? '' : dateToTimestamp(`${val[1]} 23:59:59`) 
        getPlanList()
    }

    const changeSplitDate = (row)=>{
        console.log(row,'row eeeeeeee')
        if(splitTable.value.configs.selected.length > 0){
            splitTable.value.configs.selected.forEach(i=>{
                i.child.innerDatas.forEach(j=>{ 
                    if(j.index == row.index){
                        j.record_date = row.record_date
                    }
                })
            })
        }
        // console.log(splitTable.value.configs.selected,' pppppp')
    }

    const selectRow = (selectedData) => {
        console.log(selectedData, 'wwwwwwwwww')
        splitTable.value.configs.selected = JSON.parse(JSON.stringify(selectedData))
    }

    const selectRowMaisach = (selectedRows, selectedRowKeys) => {
        maisachTable.value.configs.selected = selectedRows;
    };
    const expandRow = (rowKey,record)=>{
        splitTableRef.value.expandedKeys = splitTableRef.value.expandedKeys.length !== 0? [record.id] : []
        rowData.value = record
    }

    const selectSKU = (val)=>{
        console.log(val,'val')
    }

    /*
    const onBeforeSelectSKUOk = ()=>{
        splitVisible.value = true
        SKUVisible.value = false
        splitTable.value.configs.selected = []
        splitTableRef.value.selectedData = []
        splitTableRef.value.selectedKeys = []
        splitTableRef.value.expandedKeys = []
        getSplitList()
        return true
    }
   */

    const onBeforeSelectSKUOk = ()=>{
        if(!sku.value){
            Message.error(t('plan.selectSKU'));
            return false
        }

        if(currentOperation.value == 'split'){
            splitVisible.value = true
            splitTable.value.configs.selected = []
            splitTableRef.value.selectedData = []
            splitTableRef.value.selectedKeys = []
            splitTableRef.value.expandedKeys = []
            getSplitList()
        }else if(currentOperation.value === 'maisach'){
            maisachVisible.value = true
             maisachTable.value.configs.selected = []
             maisachTableRef.value.selectedData = []
             maisachTableRef.value.selectedKeys = []
             getMaisachList()
        }  

        return true     
    }
    

    const changeInputNumber = (val, row, type)=>{
        console.log(val, row,'innerdata', rowData.value)
        switch(type){
            case 'quantity':
                let total_quantity = 0
                row.quantity = val
                rowData.value.child.innerDatas.forEach(i=>{
                    total_quantity += Number(i.quantity)
                })

                if(row.rest_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip2'),  duration: 5000 })
                    return
                }else if(row.in_stock_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip3'),  duration: 5000 })
                    return
                }else if(row.in_transit_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip4'),  duration: 5000 })
                    return
                }else if(total_quantity > rowData.value.quantity){
                    Message.error({ content: t('plan.quantityTip'),  duration: 5000 })
                    return
                }
                break;
            case 'rest_quantity':
                let total_rest_quantity = 0
                row.rest_quantity = val
                rowData.value.child.innerDatas.forEach(i=>{
                    total_rest_quantity += Number(i.rest_quantity)
                })
                
                if(row.rest_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip2'),  duration: 5000 })
                    return
                }else if(total_rest_quantity > rowData.value.rest_quantity){
                    Message.error({ content: t('plan.restQtyTip'),  duration: 5000 })
                    return
                }
                break;
            case 'in_transit_quantity':
                let total_in_transit_quantity = 0
                row.in_transit_quantity = val
                rowData.value.child.innerDatas.forEach(i=>{
                    total_in_transit_quantity += Number(i.in_transit_quantity)
                })

                if(row.in_transit_quantity < row.in_stock_quantity){
                    Message.error({ content: t('plan.quantityTip5'),  duration: 5000 })
                    return
                }else if(row.in_transit_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip4'),  duration: 5000 })
                    return
                }else if(total_in_transit_quantity > rowData.value.in_transit_quantity){
                    Message.error({ content: t('plan.inTransitQtyTip'),  duration: 5000 })
                    return
                }

                if(row.in_transit_quantity > 0) row.rest_quantity = 0
                break;
            case 'in_stock_quantity':
                let total_in_stock_quantity = 0
                row.in_stock_quantity = val
                rowData.value.child.innerDatas.forEach(i=>{
                    total_in_stock_quantity += Number(i.in_stock_quantity)
                })

                if(row.in_stock_quantity > row.in_transit_quantity){
                    console.log('jin')
                    Message.error({ content: t('plan.quantityTip5'),  duration: 5000 })
                    return
                }else if(row.in_stock_quantity > row.quantity){
                    Message.error({ content: t('plan.quantityTip3'),  duration: 5000 })
                    return
                }else if(total_in_stock_quantity > rowData.value.in_stock_quantity){
                    Message.error({ content: t('plan.inStockQtyTip'),  duration: 5000 })
                    return
                }

                if(row.in_stock_quantity > 0) row.rest_quantity = 0
                break;
                
            case 'maisach_in_stock_quantity':
                const inputVal = Number(val) || 0
         
                let processedVal = inputVal
                if (processedVal < 0) {
                    processedVal = 0;Message.error({ content: t('plan.quantityTip3'), duration: 5000 })
                }
                else if (processedVal > Number(row.quantity)) {
                processedVal = Number(row.quantity) || 0;Message.warning({ content: t('plan.quantityTip3'), duration: 5000 });
            }
            row.in_stock_quantity = processedVal;
            row.rest_quantity = (Number(row.quantity) || 0) - processedVal;
            break;

        }
    }

    // const handleWeekPickerChange = (val)=>{
    //     addForm.formData.record_week = getWeek(val)
    // }

    // 上传文件 
    // const Upload = (fileItem) => {
    //     // console.log(fileItem,'fileList')
    //     importFile(fileItem.file)
    // }

    // 导出
    const exportFile = async ()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'record_date'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        let param = {
            ...form,
            begin_date: queryForm.formData.begin_date,
            end_date: queryForm.formData.end_date,
        }
        Message.success(t('base.exporting'))
        table.value.configs.loading = true

        let res = await ProductApi.getInstance().exportPlanList(param)
        if(!res.code){
            let blob = new Blob([res])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `${t('plan.planData')}.xlsx`
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)
            Message.success(t('base.exportSuccess'))
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 编辑日期
    const disabledDate = (current)=>{
        let everyDate = new Date(current).getTime() // 日期组件每天日期
        let currentDate = dateToTimestamp(`${getNowDate()} 00:00:00`)  // 当前日期

        if(Number(everyDate.toString().substring(0,10)) < Number(currentDate)){
            return true
        }else{
            return false
        }
    }

    // 导入
    // const importFile = async(file)=>{
    //     let form = new FormData();
    //     form.append('file', file)
    //     Message.success(t('plan.importing'))
    //     let res = await PlanApi.getInstance().importData(form)
    //     if(res.code == 0){
    //         Message.success(t('plan.importSuccess'))
    //         table.value.configs.pagination.current = 1
    //         getPlanList()
    //     }else{  
    //         Message.error(t('plan.importFail') + res.msg)
    //     }
    // }

    // 下载导入模板
    // const downLoadImportTemplate = async()=>{
    //     let param = {
    //         dict_code:'email_template',
    //         dict_sub_code:'product_plan',
    //     }
    //     let res = await PlanApi.getInstance().getImportTemplate(param)
    //     if(res.code == 0){
    //         let name = res.data[0].dict_sub_name
    //         let path = res.data[0].dict_sub_value
    //         let xhr = new XMLHttpRequest();
    //         xhr.open('GET',path,true)
    //         xhr.responseType = 'blob'
    //         xhr.onload = ()=>{
    //             let url = window.URL.createObjectURL(xhr.response)
    //             let a = document.createElement('a')
    //             a.href = url
    //             a.download = name
    //             a.click()
    //         }
    //         xhr.send();
    //         Message.success(t('plan.downloadTemplateSuccess'))
    //     }else{  
    //         Message.error(res.msg)
    //     }
    // }

    // 获取计划列表
    const getPlanList = async()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'record_date'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        let param = {
            ...form,
            begin_date: queryForm.formData.begin_date,
            end_date: queryForm.formData.end_date,
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await ProductApi.getInstance().getPlanList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.length > 0 &&  res.data.records.forEach((i,index)=>{
                i.No = index + 1
                i.record_date = !i.record_date? '-' : timestampToDate(i.record_date * 1000).split(' ')[0]
            })
            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{  
            Message.error(res.msg)
        }
    }

    // 确认保存
    const onBeforeOk = async()=>{
        if(!recordDate.value){
            Message.error(t('plan.recordDate')+ ' ' +t('base.noEmpty'))
            return false
        }

        let param = {
            record_timestamp: dateToTimestamp(recordDate.value),
            id: rowData.value.id
        }
        let res = await ProductApi.getInstance().editPlanDate(param, rowData.value.id)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            visible.value = false
            table.value.configs.pagination.current = 1
            getPlanList()
        }else{  
            Message.error(res.msg)
        } 
    }

    // 获取拆分数据
    const getSplitList = async()=>{
        let param = {
            sku: sku.value
        }
        splitTable.value.loading = true
        let res = await ProductApi.getInstance().getSplitList(param)
        if(res.code == 0){
            splitTable.value.datas = []
            if(res.data && res.data.length > 0){
                res.data.forEach((i,index)=>{
                    i.index = index
                    i.No = index + 1
                    i.id = index + 1
                    i.child = {
                        innerDatas: i.lines.map((item,subIndex)=>{
                            return {
                                ...item,
                                index: subIndex,
                                No: `${index + 1}-${subIndex + 1}`,
                                in_transit_quantity: item.in_transit_quantity == undefined? 0 : item.in_transit_quantity,
                                in_stock_quantity: item.in_stock_quantity == undefined? 0 : item.in_stock_quantity,
                                record_date: timestampToDate(item.record_date * 1000).split(' ')[0],
                            }
                        }),
                        innerColumns:innerColumns.value,
                        innerConfigs:innerConfigs.value,
                    }
                })
                splitTable.value.datas = res.data
            }
            splitTable.value.loading = false
        }else{  
            Message.error(res.msg)
        } 
    }

    // 保存拆分数据
    const saveSplitData = async()=>{
        let tableSelectData = [] // splitTable.value.configs.selected

        splitTable.value.datas.forEach(i=>{
            splitTable.value.configs.selected.forEach(j=>{
                if(j.id == i.id){
                    j.child.innerDatas = i.child.innerDatas
                    tableSelectData.push(j)
                }
            })
        })

        if(tableSelectData.length == 0){
            Message.error(t('base.selecteData'))
            return false
        }

        console.log(tableSelectData,'tableSelectData 77777', splitTable.value.datas)
        for(let i=0; i<tableSelectData.length; i++){
            let item = tableSelectData[i]
            let all_quantity = 0,
                all_rest_quantity = 0,
                all_in_stock_quantity = 0,
                all_in_transit_quantity = 0,

                total_quantity = 0,
                total_rest_quantity = 0,
                total_in_stock_quantity = 0,
                total_in_transit_quantity = 0

            for(let j=0; j<item.child.innerDatas.length; j++){
                let item2 = item.child.innerDatas[j]

                if(item2.quantity === '' || item2.quantity === undefined){ // 检查是否为空
                    Message.error({ content: `【#${item2.No}】` + ' ' + t('plan.quantity') + ' ' + t('base.noEmpty'),  duration: 3000 })
                    return false
                }else if(item2.rest_quantity === '' || item2.rest_quantity === undefined){
                    Message.error({ content: `【#${item2.No}】` + ' ' + t('plan.restQuantity') + ' ' + t('base.noEmpty'),  duration: 3000 })
                    return false
                }else if(item2.in_transit_quantity === '' || item2.in_transit_quantity === undefined){
                    Message.error({ content: `【#${item2.No}】` + ' ' + t('plan.inTransitQuantity') + ' ' + t('base.noEmpty'),  duration: 3000 })
                    return false
                }else if(item2.in_stock_quantity === '' || item2.in_stock_quantity === undefined){    
                    Message.error({ content: `【#${item2.No}】` + ' ' + t('plan.inStockQuantity') + ' ' + t('base.noEmpty'),  duration: 3000 })
                    return false
                }else if(item2.record_date === '' || item2.record_date === undefined){
                    Message.error({ content: `【#${item2.No}】` + ' ' + t('plan.recordDate') + ' ' + t('base.noEmpty'),  duration: 3000 })
                    return false
                }if(item2.rest_quantity > item2.quantity){ // quantity 检查
                    Message.error({ content: `【#${item2.No}】` + ' ' +  t('plan.quantityTip2'),  duration: 3000 })
                    return false
                }else if(item2.in_stock_quantity > item2.quantity){
                    Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.quantityTip3'),  duration: 3000 })
                    return false
                }else if(item2.in_transit_quantity > item2.quantity){
                    Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.quantityTip4'),  duration: 3000 })
                    return false
                }else if(item2.in_stock_quantity > item2.in_transit_quantity){
                    Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.quantityTip5'),  duration: 3000 })
                    return false
                }

                all_quantity += Number(item2.quantity)
                all_rest_quantity += Number(item2.rest_quantity)
                all_in_stock_quantity += Number(item2.in_stock_quantity)
                all_in_transit_quantity += Number(item2.in_transit_quantity)

                if(
                    (item.quantity !== '' || item.quantity !== undefined) && 
                    (item.rest_quantity !== '' || item.rest_quantity !== undefined) && 
                    (item.in_stock_quantity !== '' || item.in_stock_quantity !== undefined) && 
                    (item.in_transit_quantity !== '' || item.in_transit_quantity !== undefined)
                ){
                    if(total_quantity > item.quantity){ // 行数量和是否大于头数量
                        Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.quantityTip'),  duration: 3000 })
                        return false
                    }else if(total_rest_quantity > item.rest_quantity){
                        Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.restQtyTip'),  duration: 3000 })
                        return  false
                    }else if(total_in_transit_quantity > item.in_transit_quantity){
                        Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.inTransitQtyTip'),  duration: 3000 })
                        return false
                    }else if(total_in_stock_quantity > item.in_stock_quantity){
                        Message.error({ content:  `【#${item2.No}】` + ' ' + t('plan.inStockQtyTip'),  duration: 3000 })
                        return false
                    }
                }
            }

            console.log(all_quantity,item.quantity,'all_quantity')
            
            for(let j=0; j<item.child.innerDatas.length; j++){
                if(all_quantity !== item.quantity){ // 检查数量是否一致
                    Message.error({ content: `【# ${item.No}】` + ' ' + t('plan.quantityTip6'),  duration: 3000 })
                    return false
                }else if(all_rest_quantity !== item.rest_quantity){
                    Message.error({ content: `【# ${item.No}】` + ' ' + t('plan.restQtyTip2'),  duration: 3000 })
                    return false
                }else if(all_in_transit_quantity !== item.in_transit_quantity){
                    Message.error({ content: `【# ${item.No}】` + ' ' + t('plan.inTransitQtyTip2'),  duration: 3000 })
                    return false
                }else if(all_in_stock_quantity !== item.in_stock_quantity){
                    Message.error({ content: `【# ${item.No}】` + ' ' + t('plan.inStockQtyTip2'),  duration: 3000 })
                    return false
                }
            }
        }

        console.log(tableSelectData, 'tableSelectData')
        let arr = []
        tableSelectData.forEach(i=>{
            arr.push({
                sku: i.sku,
                factory: i.factory,
                process_code: i.process_code,
                lines: i.child.innerDatas.map(val=>{
                    return {
                        quantity: val.quantity,
                        rest_quantity: val.rest_quantity,
                        in_transit_quantity: val.in_transit_quantity,
                        in_stock_quantity: val.in_stock_quantity,
                        record_timestamp:  dateToTimestamp(val.record_date),
                    }
                }),
            })
        })

        console.log(arr,'arr')

        splitTable.value.loading = true
        saveDisabled.value = true
        let res = await ProductApi.getInstance().saveSplitData(arr)
        if(res.code == 0){
            Message.success(t('base.saveSuccess'))
            splitTable.value.loading = false
            saveDisabled.value = false
            getPlanList()
            return true
        }else{
            Modal.error({
                title: t('base.error'),
                content: res.msg,
                okText: t('base.ok'),
                maskClosable:false,
                onOk: () => {}
            })

            saveDisabled.value = false
            return false
        } 
    }

    //获取Maisach数据
    const getMaisachList = async()=>{
        let param = {
            sku: sku.value,
        }
        maisachTable.value.loading = true
         let res = await ProductApi.getInstance().getMaisachList(param)
         if(res.code == 0){
            maisachTable.value.datas = []
            if(res.data && res.data.length > 0){
                res.data.forEach((i, index) => {
                    i.index = index
                    i.No = index + 1
                    i.record_date = !i.record_date? '-' : timestampToDate(i.record_date * 1000).split(' ')[0]
                    i.maisach_quantity = i.quantity || 0
                    i.maisach_in_stock_quantity = i.maisach_in_stock_quantity || 0
                    i.maisach_rest_quantity = i.maisach_rest_quantity || 0
                })
                maisachTable.value.datas = res.data
            }
            maisachTable.value.loading = false
                
         } else {
                Message.error(res.msg || t('base.error'))
                maisachTable.value.loading = false
         }
    }

    // 保存Maisach数据
    const updateMaisachStock = async () => {
        const selectedRows = maisachTable.value.configs.selected;
        if (selectedRows.length == 0) {
            Message.error(t('base.selectData'));
            return false;
        }
        for (const row of selectedRows) {
            const inStockQty = Number(row.in_stock_quantity) || 0;
            const qty = Number(row.quantity) || 0;
    
            if (inStockQty > qty) {
                Message.error(t('plan.quantityTip3'));
                return false;
             }
        }

        const submitData = maisachTable.value.configs.selected.map(item => ({
            id: item.id,
            sku: item.sku,
            factory: item.factory,
            quantity: item.quantity,
            rest_quantity: item.rest_quantity,
            in_stock_quantity: item.in_stock_quantity,
            process_code: item.process_code,
            record_date: dateToTimestamp(item.record_date), 
            source_po: item.source_po
        }));

        saveDisabled.value = true;
        const res = await ProductApi.getInstance().updateMaisachStock(submitData);
        if (res.code === 0) {
            maisachVisible.value = false;
            getPlanList();
            saveDisabled.value = false
            return true;
        } else {
            Modal.error({
                title: t('base.error'),
                content: res.msg,
                okText: t('base.ok'),
                maskClosable:false,
                onOk: () => {}
            })
            saveDisabled.value = false
            return false;
        }
    }
    // 获取历史记录
    const getRecordList = async ()=>{
        let param = {
            ...queryRecordForm.formData,
        }
        let page_num = recordTable.value.configs.pagination.current
        let page_size = recordTable.value.configs.pagination.pageSize
        recordTable.value.loading = true
        let res = await ProductApi.getInstance().getRecordList(param, page_num,page_size)
        if(res.code == 0){
            res.data.records.length > 0 && res.data.records.forEach((i,index)=>{
                i.index = index
                i.No = index + 1
                i.record_date = !i.record_date? '-' : timestampToDate(i.record_date * 1000).split(' ')[0]
            })
            recordTable.value.datas = res.data.records
            recordTable.value.configs.pagination.total = res.data.total
            recordTable.value.loading = false
        }else{  
            Message.error(res.msg)
        } 
    }

    // 获取产品列表,拿到SKU    {simple_flag:1}
    const getSku = async ()=>{
        let res = await OrderApi.getInstance().getProductList()
        if(res.code == 0){
            skuOption.value = []
            let item = queryForm.formField.find(i=>i.key == 'sku')
            let item2 = queryRecordForm.formField.find(i=>i.key == 'sku')

            item.options = []  
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.category_code == '627.501'){
                    skuOption.value.push({
                        label:i.sku,
                        value:i.sku,
                        code:i.inventory_code,
                        category_code:i.category_code,
                        name:i.english_name,
                    })
                    item.options.push({
                        label:i.sku,
                        value:i.sku,
                    })
                    item2.options.push({
                        label:i.sku,
                        value:i.sku,
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }
    

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 100
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })


    onMounted(()=>{
        getSku()
        getPlanList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

// 表格
/deep/ .arco-table-td{
    padding: 5px 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

.tableList{
    /deep/ .arco-table-th{
        background: #fff;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        font-size: 13px;
        font-weight: 600;
    }
}


/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

.addLine{
    margin: 10px 0 0;
}

.addTable{
    /deep/ .arco-pagination{
        display: none;
    }
}

.importFile{
    display: inline-block;

    /deep/ .arco-btn-size-mini{
        height: 24px;
        padding: 0 11px;
        font-size: 12px;
        vertical-align: middle;
        margin-top: -5px;
    }
}

/deep/ .arco-modal-body{
    text-align: center;
}

/deep/.splitTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background: #fff;
    }

    .arco-icon-filter{
        color: #fff;
    }

    
}

/deep/.maisachTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background: #fff;
    }

    .arco-icon-filter{
        color: #fff;
    }

    
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-table-filters svg{
    color: #fff;
}
</style>